import { render, staticRenderFns } from "./summaryTwitter.vue?vue&type=template&id=809eb490&scoped=true&"
import script from "./summaryTwitter.vue?vue&type=script&lang=js&"
export * from "./summaryTwitter.vue?vue&type=script&lang=js&"
import style0 from "./summaryTwitter.vue?vue&type=style&index=0&id=809eb490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809eb490",
  null
  
)

export default component.exports